import type { FC } from "react";
import { cn } from "@/lib/cn";
import { DotList } from "./dot-list";

type ExperienceBlockProps = {
  yearsOfExperience?: number;
  clientTypes?: string[];
  className?: string;
};

export const ExperienceBlock: FC<ExperienceBlockProps> = ({ yearsOfExperience, clientTypes, className }) => {
  const cleanedClientTypes = (clientTypes ?? []).filter((item) => Boolean(item?.trim()));
  const hasYears = yearsOfExperience !== undefined && yearsOfExperience > 0;

  if (!hasYears && cleanedClientTypes.length === 0) return null;

  return (
    <div className={cn("flex flex-col gap-16", className)}>
      {hasYears && (
        <p className="text-21 leading-[1.2] text-neutral-black">{yearsOfExperience}+ years of experience</p>
      )}
      {cleanedClientTypes.length > 0 && (
        <div className="flex flex-col gap-4">
          <span className="text-14 text-neutral-grey">Client types</span>
          <DotList items={cleanedClientTypes} itemClassName="text-14 text-neutral-black" />
        </div>
      )}
    </div>
  );
};
